import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Ukd } from "../models/SearchService/ukd.model";
import { Ukt } from "../models/SearchService/ukt.model";

@Injectable({
  providedIn: "root"
})
export class UkHttpClientService {
  private readonly base = environment.backendBaseUrl;
  private readonly endpoint = "/api/ukt";
  private readonly fullPath = `${this.base}${this.endpoint}`;
  private readonly searchUkdURL = `${this.fullPath}/search/ukd`;
  private readonly searchUktURL = `${this.fullPath}/search/ukmun`;
  private readonly CCUktURL = `${this.fullPath}/ukmun/start-cc`;
  private readonly CCUkdURL = `${this.fullPath}/ukd/start-cc`;
  private readonly walletUktURL = `${this.fullPath}/ukmun/payment/web`;
  private readonly walletUkdURL = `${this.fullPath}/ukd/payment/web`;
  private readonly ukCitiesURL = `${this.base}/api/services/uk-cities`;

  constructor(private http: HttpClient) {}

  SearchUkt(contractNumber: string, institutionCode: string) {
    const params = new HttpParams()
      .set("contractNumber", contractNumber)
      .append("institutionCode", institutionCode);

    return this.http.get<Ukt[]>(this.searchUktURL, {
      params
    });
  }

  SearchUkd(contractNumber: string, institutionCode: string) {
    const params = new HttpParams()
      .set("contractNumber", contractNumber)
      .append("institutionCode", institutionCode);

    return this.http.get<Ukd[]>(this.searchUkdURL, {
      params
    });
  }

  PayUktCC(invoice: any) {
    return this.http.post<any>(`${this.CCUktURL}`, invoice);
  }

  PayUkdCC(invoice: any) {
    return this.http.post<any>(`${this.CCUkdURL}`, invoice);
  }

  PayUktWallet(invoice: any) {
    return this.http.post<any>(`${this.walletUktURL}`, invoice);
  }

  PayUkdWallet(invoice: any) {
    return this.http.post<any>(`${this.walletUkdURL}`, invoice);
  }

  GetUkCities(){
    return this.http.get<any>(`${this.ukCitiesURL}`);
  }
}
